<style lang="scss" scoped>
.slide-10 {
  background-image: url(../../../assets/module3/slide10/background-01.jpg);
  background-size: cover;
  background-position: center;
  height: calc(100% - 100px);
  padding: 50px 0;
}

.page-left {
  flex-basis: 40%;
}
.page-right {
  flex-basis: 60%;
}

.heading1,
.heading2 {
  color: #3b7fc2;
  transform: rotate(-5deg);
}

.heading2 {
  margin-left: 60px;
}

.heading3,
.heading4,
.heading5 {
  color: #edad0a;
}

.heading3 {
  margin-top: 50px;
  margin-left: 100px;
}

.heading5 {
  margin-left: 10px;
}

.copy {
  color: #000;
  width: 60%;
  margin-left: auto;

  &:nth-child(1) {
    margin-top: 50px;
  }
}
.download {
  width: 200px;
  display: block;
  position: absolute;
  left: 50%;
  top: 37%;
  cursor: pointer;
  transition: all 0.2s ease-out;
  &:hover {
    transform: scale(1.1);
  }
}
</style>

<template>
  <div class="slide-10">
    <transition name="fadeLeft" appear>
      <img
        v-show="slideIndex == 9"
        src="@/assets/module3/slide10/poster.png"
        class="chars delay-1"
      />
    </transition>
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 9"
        src="@/assets/module3/slide10/scissors_pins.png"
        class="chars delay-2"
      />
    </transition>

    <div class="pages">
      <div class="page page-left"></div>

      <div class="page page-right">
        <transition name="scale" appear>
          <div class="delay-3" v-show="slideIndex == 9">
            <h1 class="heading1">{{ $t("module3.slide10.heading1") }}</h1>
            <h1 class="heading2">{{ $t("module3.slide10.heading2") }}</h1>
            <h1 class="heading3">{{ $t("module3.slide10.heading3") }}</h1>
            <h1 class="heading4">{{ $t("module3.slide10.heading4") }}</h1>
            <h1 class="heading5">{{ $t("module3.slide10.heading5") }}</h1>
          </div>
        </transition>

        <transition name="scale" appear>
          <a
            :href="pdfFile"
            class="download delay-2"
            v-show="slideIndex == 9"
            target="_blank"
          >
            <img src="@/assets/module3/slide10/1x/dowload_print.png" />
          </a>
        </transition>

        <transition name="fadeRight" appear>
          <div clsss="delay-4 copy-wrapper" v-show="slideIndex == 9">
            <p class="copy">{{ $t("module3.slide10.copy1") }}</p>
            <p class="copy">{{ $t("module3.slide10.copy2") }}</p>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pdfFile:
        window?.CF_EBOOK_VARS?.documents?.book_3_document_1?.url ||
        "../Week-3-Arman-Cut-Out.pdf"
    };
  },
  props: {
    slideIndex: { type: Number },
    imageBlob: { type: String, default: undefined },
    imageId: { type: String, default: "0" },
    downloadLegacy: { type: Function, default: null }
  },
  methods: {}
};
</script>
